<template>
    <div class="flex flex-col md:flex-row bg-gradient-to-b from-[#FFF1F3] from-[30%] to-white rounded-[20px] text-black md:bg-gradient-to-b md:from-[#FFF1F3] md:from-[30%] md:to-white">
        <div class="flex flex-col px-5 py-5 pb-0 md:pb-5 cursor-default rounded-[20px] bg-white gap-5">
            <div v-for="(item, i) in navItems" :key="i">
                <nuxt-link hreflang="en-ca" :to="item.path" class="group flex flex-col md:flex-row pl-4 pr-4 py-4 md:pl-7 md:pr-5 no-underline text-black rounded-xl border border-[#F4F4F4] bg-white gap-3 md:gap-8 hover:border-[#FF647F] hover:no-underline hover:text-inherit focus:[&_*]:!text-black style-1-nav-item">
                    <div class="flex">
                        <img :src="$image(item.imgPath)" :alt="item.title" class="w-20 h-20 md:w-[120px] md:h-[120px] mr-4 md:mr-0 max-w-none">
                        <div class="flex flex-col gap-2 md:hidden">
                            <span class="font-manrope text-lg leading-6 font-bold tracking-[-0.75px] md:text-xl md:leading-7 md:font-extrabold">{{ item.title }}</span>
                            <div class="p-1 bg-[#F4F4F4] h-7 w-max rounded icon-container group-hover:text-primary-700">
                                <UIcon name="i-pkg-navigation-arrow-right" class="size-5" />
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col justify-center gap-3">
                        <div class="hidden md:flex items-center gap-2">
                            <span class="font-manrope text-xl leading-7 font-extrabold tracking-[-0.75px]">{{ item.title }}</span>
                            <div class="p-1 bg-[#F4F4F4] h-7 w-max rounded icon-container group-hover:text-primary-700">
                                <UIcon name="i-pkg-navigation-arrow-right" class="size-5" />
                            </div>
                        </div>
                        <span class="font-manrope text-sm leading-5 font-normal">{{ item.subTitle }}</span>
                    </div>
                </nuxt-link>
            </div>
        </div>
        <Divider class="w-[90%] h-[2px] my-5 mx-auto bg-[#F4F4F4] md:w-[2px] md:h-auto md:my-0 md:mx-6 only-device px-5" />
        <div class="cursor-default w-full flex flex-col justify-end px-5 pb-5 md:w-[60%] md:justify-center md:px-10 md:py-20">
            <span class="font-manrope text-base leading-5 tracking-[-0.3px] font-bold mb-2">
                Why Peekage?
            </span>
            <span class="font-manrope text-xs leading-5 font-normal mb-5 md:mb-8">Access a diverse community of 5M+ shoppers and drive retail velocity with geo-targeting. Get live consumer data in days, not weeks, with affordable, all-in-one product testing solutions that are easy to use, requiring no data science expertise.</span>
            <div class="flex cursor-pointer w-fit items-center gap-0.5 text-[#FF3357]" @click="handleScroll">
                <span class="font-manrope text-sm leading-4 font-bold tracking-[-0.3px]">Learn more</span>
                <UIcon name="i-pkg-navigation-arrow-right" class="size-4 shrink-0 text-[#FF3357]" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Style1NavItem {
    type: string
    path: string
    imgPath: string
    title: string
    subTitle: string
}

const props = withDefaults(defineProps<{
    subMenus?: Style1NavItem[]
}>(), {
    subMenus: () => [],
})

const route = useRoute()
const router = useRouter()

const navItems = computed(() => props.subMenus.filter(item => item.type === 'NAV_ITEM'))

const handleScroll = async () => {
    if (!import.meta.client) {
        return
    }
    if (route.path !== '/') {
        await router.push('/#WhyPeekage')
    }
    const el = document.getElementById('WhyPeekage')
    if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
    }
}
</script>

<style lang="scss" scoped>
    .style-1-nav-item {
        .icon-container{
            .icon-arrow {
                background-color: #515151;
            }
        }

        &:hover {
            .icon-container{
                background-color: #FFDFE5;
                .icon-arrow {
                    background-color: #ED1138;
                }
            }
        }
    }
</style>
